export default __webpack_public_path__ + "static/Catwalk-373c72cc86c327b875d2493b466d36e2.png";